import 'consumerweb-shim';
import 'adsinterceptor';
import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import getContent, { init } from 'react-i18n';
import Footer from 'marketing-components/dist/components/organisms/footer';
import Header from 'marketing-components/dist/components/organisms/header';
import { Text, grey600 } from 'pp-react';
import glamorous from 'glamorous';

import * as analytics from '../lib/analytics';

import store from '../components/redux/store/configStore';
import SearchBox from '../components/searchBox';
import HubSocialShare from '../components/HubSocialShare';
import Tiles from '../components/tiles';
import Confirmation from '../components/confirmation';
import CheckoutError from '../components/checkoutError';
import DonationSteps from '../components/donation-steps';
import Stripe from '../components/stripe';
import FAQBanner from '../components/faqBanner';
import CharityDesktop from '../components/redux/containers/featuredDesktopContainer';
// import NearByDesktop from './components/redux/containers/nearByDesktopContainer';
// import NearByMobile from './components/redux/containers/nearByMobileContainer';
import CharityMobile from '../components/redux/containers/featuredMobileContainer';
// import Recommendation from './components/recommendation';

import DataPropsContent from '../lib/getDataProps';
const { personalization } = DataPropsContent;

const {
  heroImageURL,
  heroImageHeader,
  heroImageSubheader,
  legalContent,
  confTitle,
  confSubTitle,
} = personalization || {};

if (window.PAYPAL && window.PAYPAL.analytics) {
  window.PAYPAL.analytics.startClientErrorTracking();
}

const LegalText = glamorous(Text)({
  color: grey600,
});

class Page extends React.Component {
  static propTypes = {
    csrf: PropTypes.string,
    featured: PropTypes.array,
    categories: PropTypes.array,
    donationInfo: PropTypes.object,
  };

  static childContextTypes = {
    csrf: PropTypes.string,
  };

  constructor(props, context) {
    super(props, context);
    var nameValues = this.parseFPTIInfo(props && props.fptiInfo);

    var initialState = {
      fptiInfo: {
        pgrp: nameValues.pgrp,
        page: nameValues.page,
      },
      isMobile: false,
    };
    this.state = initialState;
  }

  parseFPTIInfo = fptiData => {
    var nameValues = [];
    var pairs = decodeURIComponent(fptiData).split('&');
    var i;
    for (i = 0; i < pairs.length; i++) {
      var parts = pairs[i].split('=');
      nameValues[parts[0]] = parts[1];
    }
    return nameValues;
  };

  componentDidMount() {
    let isMobile = false;
    if (/Android|webOS|iPhone|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      isMobile = true;
      this.setState({
        isMobile,
      });
    }

    // to replace the default /signin href from marketing header
    // we need it to go back to npo page
    const marketingULButton = document.getElementById('ul-btn') || {};
    marketingULButton.href = this.props.unifiedLoginURL;
  }

  getChildContext() {
    return {
      csrf: this.props.csrf,
    };
  }

  handleAnalytics = click => {
    analytics.trackLink(
      click,
      this.state.fptiInfo.pgrp,
      this.state.fptiInfo.page,
      'link'
    );
  };

  renderCharityModule = () => {
    return (
      <div style={{ marginBottom: '20px' }}>
        <Provider store={store}>
          <div>
            {this.props.deviceType !== 'MOBILE' && (
              <CharityDesktop fptiInfo={this.state.fptiInfo} />
            )}
            {this.props.deviceType === 'MOBILE' && (
              <CharityMobile fptiInfo={this.state.fptiInfo} />
            )}
          </div>
        </Provider>
      </div>
    );
  };

  // renderNearByModule() {
  //   if (!isEmpty(this.props.nearBy)) {
  //     return (
  //       <div style={{ marginBottom: '20px' }}>
  //         <Provider store={store}>
  //           <div>
  //             {this.props.deviceType !== 'MOBILE' &&
  //               <NearByDesktop fptiInfo={this.state.fptiInfo} />}
  //             {this.props.deviceType === 'MOBILE' &&
  //               <NearByMobile fptiInfo={this.state.fptiInfo} />}
  //           </div>
  //         </Provider>
  //       </div>
  //     );
  //   }
  // },

  // renderRecommendationModule() {
  //   const toRender = !isEmpty(recommended);
  //   if (toRender) {
  //     return (
  //       <div>
  //         <Recommendation
  //           npid={this.props.recommended.nonprofit_id}
  //           logoUrl={this.props.recommended.logo_url}
  //           charityName={this.props.recommended.name}
  //         />
  //         <hr className={'reco-border'} />
  //       </div>
  //     );
  //   }
  // },

  renderFooter = () => {
    const {
      content: { content: footerContent },
    } = JSON.parse(document.getElementById('data-footer').innerHTML);
    const { localeCountry } = footerContent;

    return (
      <Footer
        content={footerContent}
        localeCountry={localeCountry}
        flagHref={`https://www.paypal.com/${localeCountry.toLowerCase()}/webapps/mpp/country-worldwide`}
      />
    );
  };

  renderHeader = () => {
    // https://github.paypal.com/MPPContentDevelopment/marketing-components#client
    const {
      content: { contentLoggedOut: content, config },
    } = JSON.parse(document.getElementById('data-header').innerHTML);

    const props = { content, config };

    return (
      <div className={'marketing-header-background'}>
        <Header {...props} />
      </div>
    );
  };

  render() {
    const title = i18n('label.title');
    const subtitle = i18n('label.subtitle');

    return (
      <div>
        {this.props.mppHeader && this.renderHeader()}
        <div
          className={'mainHeroImage'}
          style={{
            background: `linear-gradient(rgba(0,0,0,0.55), rgba(0,0,0,0.15)), url(${heroImageURL}) no-repeat`,
            backgroundSize: 'cover',
            position: 'relative',
            backgroundPosition: 'center center',
          }}
        >
          <div className={'innerHeroContainer'}>
            <div className={'heroContent'}>
              <Text
                as='h1'
                size='xl4'
                dangerouslySetInnerHTML={{
                  __html: heroImageHeader ? heroImageHeader : title,
                }}
              />
              <Text
                as='h3'
                size='xl3'
                dangerouslySetInnerHTML={{
                  __html: heroImageSubheader ? heroImageSubheader : subtitle,
                }}
              />
            </div>
            <div className={'searchBoxDiv'}>
              <SearchBox
                {...this.props}
                isMobile={this.state.isMobile}
                fptiInfo={this.state.fptiInfo}
                searchSubmitUrl={`${this.props.coBrand}hub`}
              />
            </div>
          </div>
        </div>
        {this.props.donationInfo && this.props.donationInfo.donated === 1 && (
          <Confirmation
            title={confTitle}
            subTitle={confSubTitle}
            fptiInfo={this.state.fptiInfo}
            npoUrl={this.props.donationInfo.url}
          />
        )}
        {this.props.donationInfo && this.props.donationInfo.donated === 0 && (
          <CheckoutError fptiInfo={this.state.fptiInfo} />
        )}
        {/* {this.renderRecommendationModule()} */}
        <Stripe fptiInfo={this.state.fptiInfo} />
        {this.renderCharityModule()}
        {/* {this.renderNearByModule()} */}
        <Tiles
          id={'charityCategories'}
          renderTiles={'categories'}
          categories={this.props.categories}
          coBrand={this.props.coBrand}
          fptiInfo={this.state.fptiInfo}
        />
        <DonationSteps />
        <FAQBanner fptiInfo={this.state.fptiInfo} />
        <HubSocialShare
          url={window.location.href}
          fptiInfo={this.state.fptiInfo}
        />
        <div id={'gift'} className={'container'} style={{ marginTop: '20px' }}>
          <LegalText
            dangerouslySetInnerHTML={{
              __html: legalContent
                ? legalContent
                : i18n('label.gifts-that-do-more'),
            }}
            as='p'
            size='sm'
          />
        </div>
        {this.props.mppFooter && this.renderFooter()}
      </div>
    );
  }
}

const hub = JSON.parse(document.getElementById('data-hub').innerHTML);

const data = JSON.parse(document.getElementById('data-props').innerHTML);
const featured = data.featured;
const recommended = data.recommended || {};
const nearBy = data.nearBy;
const states = data.states;
const categories = data.categories;
const labels = data.labels;
const donation = data.donation;
const donationInfo = data.donationInfo;
const mppFooter = data.mppFooter;
const mppHeader = data.mppHeader;
const unifiedLoginURL = data.unifiedLoginURL;
const csrf = document.getElementById('data-csrf').innerHTML;
const fptiInfo = JSON.parse(
  document.getElementById('data-fpti-info').innerHTML
);
const coBrand = document.getElementById('data-co-brand').innerHTML;
const deviceType = JSON.parse(
  document.getElementById('data-deviceType').innerHTML
);
const hubUrl = `https://www.paypal.com${coBrand}hub`;

init({ contentNode: document.getElementById('data-messages') });

// Has to be executed after init
const i18n = getContent('hub/hub');

ReactDOM.render(
  <Page
    featured={featured}
    nearBy={nearBy}
    csrf={csrf}
    fptiInfo={fptiInfo}
    categories={categories}
    states={states}
    coBrand={coBrand}
    recommended={recommended}
    labels={labels}
    donation={donation}
    deviceType={deviceType}
    donationInfo={donationInfo}
    hubUrl={hubUrl}
    hub={hub}
    unifiedLoginURL={unifiedLoginURL}
    mppFooter={mppFooter}
    mppHeader={mppHeader}
  />,
  document.getElementById('page')
);
